import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-msg-popup',
  templateUrl: './msg-popup.component.html',
  styleUrl: './msg-popup.component.scss'
})
export class MsgPopupComponent {
  @Input() dialogTitle = '';

  @Input() width = 400;
  @Input() height = 120;

}
